import React from "react";

export const AuroraBorealis = ({ className = "" }: { className?: string }) => {
  return (
    <div className={`absolute inset-0 overflow-hidden pointer-events-none ${className}`}>
      {/* Primary aurora wave */}
      <div 
        className="absolute inset-0 opacity-30"
        style={{
          background: `
            radial-gradient(ellipse 80% 50% at 20% 40%, 
              hsl(152 55% 28% / 0.4) 0%, 
              transparent 50%),
            radial-gradient(ellipse 60% 40% at 80% 60%, 
              hsl(348 70% 38% / 0.3) 0%, 
              transparent 50%),
            radial-gradient(ellipse 70% 45% at 50% 30%, 
              hsl(42 75% 48% / 0.2) 0%, 
              transparent 50%)
          `,
          animation: "auroraShift 15s ease-in-out infinite",
          willChange: "transform",
        }}
      />
      
      {/* Secondary aurora layer */}
      <div 
        className="absolute inset-0 opacity-20"
        style={{
          background: `
            radial-gradient(ellipse 100% 60% at 30% 70%, 
              hsl(280 50% 40% / 0.3) 0%, 
              transparent 50%),
            radial-gradient(ellipse 80% 50% at 70% 30%, 
              hsl(200 60% 50% / 0.2) 0%, 
              transparent 50%)
          `,
          animation: "auroraShift 20s ease-in-out infinite reverse",
          willChange: "transform",
        }}
      />
      
      {/* Shimmer overlay */}
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          background: `linear-gradient(
            45deg,
            transparent 30%,
            hsl(42 75% 48% / 0.3) 50%,
            transparent 70%
          )`,
          backgroundSize: "200% 200%",
          animation: "shimmerAurora 8s ease-in-out infinite",
          willChange: "background-position",
        }}
      />
      
      <style>{`
        @keyframes auroraShift {
          0%, 100% {
            transform: translateX(0) translateY(0) scale(1);
          }
          25% {
            transform: translateX(2%) translateY(-2%) scale(1.02);
          }
          50% {
            transform: translateX(-2%) translateY(2%) scale(0.98);
          }
          75% {
            transform: translateX(-2%) translateY(-1%) scale(1.01);
          }
        }
        
        @keyframes shimmerAurora {
          0% {
            background-position: 200% 200%;
          }
          100% {
            background-position: -200% -200%;
          }
        }
      `}</style>
    </div>
  );
};
